const STORAGE_URL = 'https://hotel.upload.lk/staff';

export default STORAGE_URL;